<template>
    <div class="joinLeague">
        <div class="league-layout">
          <league-nav></league-nav>

          <div class="join-league">
            <h3>入会申请</h3>
            <div class="Con-joinLeague">
                <p class="joinLeague-tit">申请加入中国技术创业协会留学人员创业园工作委员会</p>
                <div class="joinLeague-art">
                    <div class="way" v-html="ways"></div>
                    <div class="information">
                        <p class="tit">如有任何疑问，请联系联盟秘书处：</p>
                        <p class="methods">地址：{{methods.address}}</p>
                        <p class="methods">邮编：{{methods.code}}</p>
                        <p class="methods">电话：{{methods.phone}}</p>
                        <p class="methods">邮箱：{{methods.Email}}</p>
                    </div>
                    <el-divider></el-divider>
                    附件：<el-link class="accessory"
                            :href="item"
                            target="_blank"
                            v-for="(item,index) in accessory"
                            :key="index">
                            {{item.split('_').slice(-1).join()}}
                          </el-link>
                </div>
            </div>
          </div>
        </div>

        <return-top></return-top>
    </div>
</template>

<script>
import LeagueNav from '@/components/leagueNav.vue'
import ReturnTop from '@/components/returnTop.vue'

export default {
  name: 'joinLeague',
  props: {

  },
  components: {
    LeagueNav,
    ReturnTop
  },
  data () {
    return {
      ways: '', // 加入方式
      methods: {
        address: '北京海淀区中关村大街甲59号文化大厦401室',
        code: '100872',
        phone: '010-82699858  82698998转8806',
        Email: 'lianmeng@osechina.com'
      }, // 联系信息
      accessory: '入会申请表.pdf' // 附件
    }
  },
  computed: {

  },
  created () {
    this.getjoinLeague()
  },
  mounted () {
    document.documentElement.scrollTop = 0

    this.$parent.activeIndex = '11'
  },
  methods: {
    async getjoinLeague () {
      try {
        const res = await this.$get(this.$url.league.joinLeague)

        const { code, msg, data } = res.data
        if (code === 200 && data) {
          this.ways = data.joinMethod
          this.methods.address = data.address
          this.methods.code = data.mailCode
          this.methods.phone = data.phone
          this.methods.Email = data.email
          this.accessory = data.attachment.split('&&')
          console.log(this.accessory.split('&&'))
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style scoped lang="less">
.joinLeague{
  width: 100%;
  min-height: 90vh;
  font-size: 16px;
  background-color: #F5F5F5;
  margin-top: 8px;
  overflow: hidden;
}
.league-layout{
  display: flex;
  width: 1200px;
  min-height: 790px;
  margin: 0 auto;
}
.join-league{
  width: 940px;
  min-height: 790px;
  margin: 20px auto 100px;
  background-color: #fff;
  border-radius: 2px;
  padding: 0 30px;
  overflow: hidden;
  h3{
    font-size: 20px;
    font-weight: 400;
    margin-top: 30px;
    padding-left: 15px;
    border-left: 4px solid #3056D9;
    border-radius: 2px 0 0 2px;
  }
  .Con-joinLeague{
      .joinLeague-tit{
          font-size: 22px;
          font-weight: 600;
          margin-top: 32px;
          text-align: center;
      }
      .joinLeague-art{
          .way{
              margin-top: 37px;
              font-size: 14px;
              color: #666;
              line-height: 20px;
          }
          .information{
              margin-bottom: 32px;
              .tit{
                  font-size: 16px;
                  font-weight: 600;
                  margin: 32px 0 10px;
              }
              .methods{
                  font-size: 14px;
                  color: #666;
                  line-height: 20px;
              }
          }
          .accessory{
              display: inline-block;
              margin: 0px 20px 0 0 ;
              color: #3056D9;
              font-size: 16px;
              text-decoration: underline;
          }
      }
  }
}
</style>
